import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-contents" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-xs-12 col-sm-12" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_about_license_tab = _resolveComponent("about-license-tab");
    const _component_b_tab = _resolveComponent("b-tab");
    const _component_about_app_tab = _resolveComponent("about-app-tab");
    const _component_b_tabs = _resolveComponent("b-tabs");
    const _component_StatusOverlayComponent = _resolveComponent("StatusOverlayComponent");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "form-details hidden-sm" }, [
            _createElementVNode("div", { class: "form-title" }, [
                _createElementVNode("h2", null, "\r\n                    About\r\n                ")
            ])
        ], -1 /* CACHED */)),
        _cache[3] || (_cache[3] = _createTextVNode()),
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_b_tabs, {
                        modelValue: _ctx.activeTab,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.activeTab) = $event)),
                        "nav-wrapper-class": "x_title tabs",
                        "content-class": "x_content"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_b_tab, {
                                key: "license",
                                title: "License"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_about_license_tab, { onLoadingChanged: _ctx.onLoadingChanged }, null, 8 /* PROPS */, ["onLoadingChanged"])
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _cache[1] || (_cache[1] = _createTextVNode()),
                            _createVNode(_component_b_tab, {
                                key: "app",
                                title: "App"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_about_app_tab, { onLoadingChanged: _ctx.onLoadingChanged }, null, 8 /* PROPS */, ["onLoadingChanged"])
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue"])
                ])
            ])
        ]),
        _cache[4] || (_cache[4] = _createTextVNode()),
        _createVNode(_component_StatusOverlayComponent, {
            visible: _ctx.working,
            message: "Loading..."
        }, null, 8 /* PROPS */, ["visible"])
    ]));
}
